<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="400"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-account-box</v-icon>
      </v-btn>
      
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Анкета партнера</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-3">
        <p>
          <strong>ФИО партнера:</strong> {{ partner.fullName }}
        </p>
        <p>
          <strong>Email:</strong> {{ partner.email }}
        </p>
        <p>
          <strong>Город:</strong> {{ partner.partnerCV.city }}
        </p>
        <p>
          <strong>Телефон:</strong> +7 {{ partner.partnerCV.phoneNumber }}
        </p>
        <p>
          <strong>Статус:</strong> {{ partner.partnerCV.status }}
        </p>
        <p>
          <strong>Юридический статус:</strong> {{ partner.partnerCV.legalStatus }}
        </p>
        <p>
          <strong>Доп.информация:</strong> {{ partner.partnerCV.about }}
        </p>
        <p>
          <strong>UTM:</strong> {{partner.utm}}
        </p>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'partner-cv',

  props: {
    partner: Object
  },

  data() {
    return {
      activeMode: false
    }
  },

  methods: {
    closeForm() {
      this.activeMode = false;
    }
  }
}
</script>